/* eslint-disable */
/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import {enquireScreen} from 'enquire-js';

import Banner3 from "../News/Banner3";
import {Banner30DataSource} from "../News/data.source";
import './less/antMotionStyle.less';
import Footer1 from "../Home/Footer1";
import Nav0 from "../Home/Nav0";
import {Footer10DataSource, Nav00DataSource} from "../Home/data.source";
import BreadcrumbCon from "../components/BreadcrumbCon";
import {List, Avatar, Icon} from 'antd';
import {NewsDetailDataSource} from "../common/globalDataList";
import {getWXMessage} from '../common/axios';


const listData = [];
for (let i = 0; i < 23; i++) {
    listData.push({
        href: 'news3',
        title: `西宁市电视台报道本市大气环境网格化监管系统${i}`,
        time: '2019-02-12',
        description: '',
        content: '西宁电视台新闻综合频道对“西宁市大气环境网格化监管系统”做了深入报道。 该系统由我公司承建，依托于高性能并行计算平台支撑，融合了大气环境分析预报机理和大气环境网格化监管机制， 利用科学先进的数值模式技术、同化技术、数据分析技术、GIS技术及计算机相关技术等手段， 实现大气污染预报预警与防控决策的网格化、精细化和智能化应用。系统应用后，将有力提升西宁市大气环境防控与综合治理能力， 为改善环境空气质量发挥科技先锋和专家智囊作用。',
    });
}

const IconText = ({type, text}) => (
    <span>
        <Icon type={type} style={{marginRight: 8}}/>
        {text}
    </span>
);
let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const {location} = window;

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
            show: !location.port, // 如果不是 dva 2.0 请删除
            page: 1,
            pageSize: 5,
            newsList: [],
        };
    }

    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({isMobile: !!b});
        });
        // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
        /* 如果不是 dva 2.0 请删除 start */
        if (location.port) {
            // 样式 build 时间在 200-300ms 之间;
            setTimeout(() => {
                this.setState({
                    show: true,
                });
            }, 500);
        }
        /* 如果不是 dva 2.0 请删除 end */
    }

    componentWillMount() {
        this.getWXMessage()
    }

    getWXMessage() {
        window.newsList = []
        try {
            getWXMessage().then(res => {
                console.log("res", res)
                window.newsList = []
                let list = res.data.data ? res.data.data : []
                if (list && list.length > 0) {
                    list.map(item => {
                        window.newsList.push({
                            title: item.title,
                            feTitle: item.fetitle,
                            imgList: [{title: "", url: item.imgurl}],
                            type: 'wechat',
                            url: item.url,
                            textList: [
                                item.tip,
                            ],
                        },)
                    })
                }
                NewsDetailDataSource.map((i, index) => {
                    if (index > 0) {
                        newsList.push(i)
                    }
                })
                console.log("window.newsList", window.newsList)
                this.setState({newsList: newsList});
                sessionStorage.newsList = JSON.stringify(window.newsList)
            }).catch((e)=>{
                this.setState({newsList: NewsDetailDataSource});
            })
        } catch (e) {
            console.log(e);
            this.setState({newsList: NewsDetailDataSource});
        }

    }


    chooseNews(index, item) {
        const {page, pageSize,} = this.state;
        sessionStorage.newDetailIx = (page - 1) * pageSize + index;

        if (item.type === 'wechat') {
            window.open(item.url);
        } else {
            location.href = "/#/news3";
        }
    }

    render() {
        console.log('newsList', window.newsList)
        const {pageSize} = this.state;
        const _this = this;
        const annotation = <a href="#" style={{color: "#1C7DC7"}}>新闻资讯</a>
        const children = [
            <Nav0
                id="Nav0_0"
                key="Nav0_0"
                dataSource={Nav00DataSource}
                isMobile={this.state.isMobile}
            />,
            <Banner3
                id="Banner3_0"
                key="Banner3_0"
                dataSource={Banner30DataSource}
                isMobile={this.state.isMobile}
            />,
            <div className={"container"} style={{height: '5vh',}}>
                <BreadcrumbCon pageName={annotation} pagePath={"/news2"}/>
            </div>,
            <div className={"container"} style={{minHeight: '60vh',}}>
                <List
                    className={"listNews"}
                    itemLayout="vertical"
                    size="large"
                    pagination={{
                        onChange: page => {
                            console.log(page);
                            _this.setState({page});
                        }, pageSize: pageSize,
                    }}
                    dataSource={this.state.newsList}
                    // dataSource={listData}
                    renderItem={(item, index) => (
                        <List.Item
                            key={item.title}
                            extra={
                                <img
                                    width={200}
                                    alt="logo"
                                    src="/img/new/SamplePictures.png"
                                />
                            }
                        >
                            <List.Item.Meta
                                title={<a onClick={() => this.chooseNews(index, item)}>{item.title}
                                    <div className={"line"}/>
                                    {item.feTitle}</a>}
                                // description={item.description}
                            />
                            {item.textList && item.textList.length > 0 && item.textList.map((ii, index) => {

                                if (index === 0) {
                                    return (
                                        <p>{ii}</p>
                                    )
                                }
                            })}
                        </List.Item>
                    )}
                />
            </div>,
            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            />,
        ];
        return (
            <div
                className="templates-wrapper"
                ref={(d) => {
                    this.dom = d;
                }}
            >
                {/* 如果不是 dva 2.0 替换成 {children} start */}
                {this.state.show && children}
                {/* 如果不是 dva 2.0 替换成 {children} end */}
            </div>
        );
    }
}
